export const TODAY_TABS = ["employees", "present", "absent", "lateRecords", "totalHours", "overtime"];

// Which people sit behind each number on the attendance board.
// Golden rule: only a checked-out day counts as attendance; open days sit with the absences.
export const pickList = (metric, rows, employees) => {
  const checkedIn = rows.filter((r) => r.check_in_at);
  const completed = checkedIn.filter((r) => r.check_out_at);
  const open = checkedIn.filter((r) => !r.check_out_at);
  const counted = new Set(completed.map((r) => r.user_id));
  if (metric === "present") return completed;
  if (metric === "lateRecords") return checkedIn.filter((r) => r.late_minutes > 0);
  if (metric === "totalHours") return completed.filter((r) => r.worked_minutes > 0);
  if (metric === "overtime") return completed.filter((r) => r.overtime_minutes > 0);
  if (metric === "absent")
    return [
      ...open,
      ...employees
        .filter((e) => !counted.has(e.id) && !open.some((r) => r.user_id === e.id))
        .map((e) => ({ user_id: e.id, employee_name: e.name, branch_name: e.job_title || "" })),
    ];
  return employees.map((e) => {
    const record = rows.find((r) => r.user_id === e.id) || {};
    return { user_id: e.id, employee_name: e.name, branch_name: e.job_title || "", ...record };
  });
};
